import {
  ContextStore,
  PageStore,
  AnalyticsStore
} from 'bernie-plugin-mobx';
import {
  Controller,
  codeSplit,
  FetchOptions,
  FetchPageOptions
} from 'bernie-core';
import { PageData } from 'bernie-http';
import { Localization } from 'bernie-l10n';
import { SearchCriteriaStore, NewCarSearchListStore, MultiItemStore } from 'stores';
import { PageId, PageURL, getMultiItemPageId } from 'utils/page-identity';
import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';

export class CarSearchController implements Controller {
  public bundles = [];
  public path = PageURL.CSR;
  public routeName = 'carSearch';
  public pageId = PageId.CSR;

  public component = codeSplit(() => import(/* webpackChunkName: 'car-search-page' */ '../views/car-search-page'));

  public exact = true;

  public async fetch(options: FetchOptions): Promise<any> {
    if (!options || !options.stores) {
      return Promise.reject('CarSearch.fetch received invalid FetchOptions');
    }
    const { stores, query, isServer } = options;
    const multiItemStore = stores.get<MultiItemStore>('multiItemStore');
    multiItemStore.setFieldsFromQuery(query);
    const carSearchListStore: NewCarSearchListStore = stores.get<NewCarSearchListStore>('carSearchListStore');
    const searchCriteriaStore: SearchCriteriaStore = stores.get<SearchCriteriaStore>('searchCriteriaStore');
    searchCriteriaStore.setMultiItemStore(multiItemStore);
    const { carSearchResult, errorInFetchingResult, recommendationContent } = carSearchListStore;
    const context: ContextStore = stores.get<ContextStore>('context');
    const page: PageStore = stores.get<PageStore>('page');
    const advertising: AdvertisingStore = stores.get<AdvertisingStore>('advertising');
    const analytics = stores.get<AnalyticsStore>('analytics');
    page.pageName = this.pageId.split(',')[0];
    advertising.trigger(page.pageName);

    searchCriteriaStore.setContext(context);
    let isSearchSubmitted = searchCriteriaStore.formSubmitted;
    const isSortAndFilterChanging = searchCriteriaStore.isSortAndFilterChanging;
    //TODO: to observe it for further use cases and need to remove it. as request needs to triger on every search
    const isQueryParamChanged = searchCriteriaStore.setSearchQuery(query);

    searchCriteriaStore.setPage(page);

    isSearchSubmitted = isSearchSubmitted || isQueryParamChanged;
    if (!isSortAndFilterChanging && !carSearchListStore.shouldResetPage && carSearchResult) {
      //Dummy api call to trigger uis prime logging when user transits from CIS back to CSR
      carSearchListStore.fireLoggingWithoutApiCall(analytics);
      carSearchListStore.shouldResetPage = true;

      return Promise.resolve({});
    }

    if ((!isSearchSubmitted && (carSearchResult || recommendationContent || errorInFetchingResult)) || isServer) {
      //We are not doing server side rendering for now
      // if query doesn't change and we have result in store already, don't make a new call
      // (!isSearchSubmitted || isServer) {
      return Promise.resolve({});
    }

    const rcpRedirect = true;

    return Promise.resolve(
      carSearchListStore.getSearchList(
        searchCriteriaStore,
        page.pageId,
        analytics,
        context,
        multiItemStore,
        rcpRedirect
      )
    );
  }

  public fetchPageData(fetchPageOptions: FetchPageOptions): Promise<PageData> {
    const localizer = new Localization(fetchPageOptions.context.locale);
    const defaultPageTitle = localizer.formatText('page.title.search.default');
    const isMultiItem = fetchPageOptions.query.misId && fetchPageOptions.query.misId.length > 0 && fetchPageOptions.query.packageType;
    const pageId = !isMultiItem ? PageId.CSR : getMultiItemPageId(fetchPageOptions.query.packageType);

    return Promise.resolve({ title : defaultPageTitle, pageId }) as Promise<PageData>;
  }
}
